import { render } from "./Wms.vue?vue&type=template&id=6812da78&scoped=true&ts=true"
import script from "./Wms.vue?vue&type=script&lang=ts"
export * from "./Wms.vue?vue&type=script&lang=ts"

import "./Wms.vue?vue&type=style&index=0&id=6812da78&scoped=true&lang=css"

import exportComponent from "D:\\YellowBeardProject\\caffeine\\caffeineshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6812da78"]])

export default __exports__